import React from "react";
import StocksList from "../../components/Stocks/StocksList";

export default function StocksScreen() {
  return <StocksList />;
}

